"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class IGO50Terminal {
}
IGO50Terminal.CurrentCode = undefined;
exports.default = IGO50Terminal;
